import React, { useState } from "react";

const DEFAULT_AVATAR = "/images/no-profile.png";

function Avatar({ src, size = 34, style = {} }) {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const showImage = src && !hasError;
  const showFallback = !isLoaded || hasError;

  return (
    <div
      style={{
        position: "relative",
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        overflow: "hidden",
        ...style,
      }}
    >
      {showFallback && (
        <img
          src={DEFAULT_AVATAR}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      )}
      {showImage && (
        <img
          src={src}
          alt=""
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      )}
    </div>
  );
}

export default Avatar;
